import { registerPlugin } from '@capacitor/core'
import type { AppUpdaterPlugin, AppUpdaterState } from './definitions'

export const AppUpdater = registerPlugin<AppUpdaterPlugin>('AppUpdater')
export type { AppUpdaterPlugin, AppUpdaterState }
